import { AddExtraMealRequest } from "@/clients/models/AddExtraMealRequest";
import { PlansService } from "@/clients/services/PlansService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useAddExtraMeal = () => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QueryKeys.PLAN_EXTRA_FOOD],
    mutationFn: async (requestBody: AddExtraMealRequest) => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await PlansService.addExtraMealApiV1PlansMealAddPost(user.id, requestBody);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.PLAN] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.MY_FOODS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.CALORIE_BUDGET] });
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey.includes(QueryKeys.BALANCE_CALORIES) ||
          query.queryKey.includes(QueryKeys.BALANCE_PROTEIN),
      });
    },
  });

  return {
    addExtraMeal: mutate,
    addExtraMealAsync: mutateAsync,
    isLoading: isPending,
    isError,
    error,
  };
};
